import React from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.scss';

export default function ChevronRightIcon({ className, size = 'tiny' }) {
  return (
    <span className={classNames(styles.svgIcon, className, styles[size])}>
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M9 18L15 12L9 6"
          stroke="var(--color-icon-lineart)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
